import { VHPDataRetriever, VhpData } from '@care/mfe-data-transfer-vhp';
import { useEffect, useState } from 'react';
import { ComeFrom, comesFromVhp } from '@/constants';

import { DataTransferMetadata } from '@/types/seeker';
import { useAppDispatch } from '../AppState';

export const isFromVhp = (comeFrom: ComeFrom | undefined) => comeFrom === comesFromVhp;
export const isFromVhpWithZip = (
  comeFrom: ComeFrom | undefined,
  dataTransferMetadata: DataTransferMetadata | undefined
) => isFromVhp(comeFrom) && dataTransferMetadata?.zipcodeSupplied;
export const useRetrieveVhpMfeSharedData = () => {
  const [isFetching, setIsFetching] = useState<boolean>(true);
  const [data, setData] = useState<VhpData | undefined>(undefined);
  useEffect(() => {
    const VHPRetriever = new VHPDataRetriever();
    setData(VHPRetriever.retrieveData());
    setIsFetching(false);
  }, []);

  return {
    isFetching,
    data,
  };
};

export const useVhpMfeSharedData = () => {
  const dispatch = useAppDispatch();
  const [isFetching, setIsFetching] = useState<boolean>(true);
  const { data } = useRetrieveVhpMfeSharedData();

  useEffect(() => {
    if (data) {
      const { zipcodeData, selectedVertical, comeFrom, featureFlagSharedData } = data;
      if (zipcodeData) {
        dispatch({ type: 'setZipcode', zipcode: zipcodeData.zipcode });
        dispatch({
          type: 'setCityAndState',
          city: zipcodeData.city,
          state: zipcodeData.state,
        });
        dispatch({
          type: 'setDataTransferMetadata',
          dataTransferMetadata: { zipcodeSupplied: true },
        });
      }
      if (selectedVertical && selectedVertical !== 'none' && selectedVertical !== 'DAYCARE') {
        dispatch({ type: 'setProviderMVServiceType', serviceType: selectedVertical });
      }
      if (comeFrom || zipcodeData || selectedVertical) {
        const source = comeFrom || 'vhp';
        dispatch({ type: 'setComeFrom', comeFrom: source });
      }
      if (featureFlagSharedData) {
        dispatch({
          type: 'setVhpFeatureFlagSharedData',
          vhpFeatureFlagSharedData: featureFlagSharedData,
        });
      }
    }

    setIsFetching(false);
  }, [data]);

  return {
    isFetching,
  };
};
